import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import classNames from 'classnames';

import { CurrencyUtils } from 'PMT/utils';

// -- entities
import { OrderMenu, OrderMenuPart } from 'PMT/entities/order';
import { Menu, MenuPart } from 'PMT/entities/menu';

// -- views
import OrderMenuPartView from './OrderMenuPartView';

export default class OrderMenuView extends Component {

  static propTypes = {
    orderMenu: PropTypes.instanceOf(OrderMenu).isRequired,

    menu: PropTypes.instanceOf(Menu).isRequired,

    quantity: PropTypes.number.isRequired,

    currencyCode: PropTypes.string,

  };

  get orderMenu(): OrderMenu {
    return this.props.orderMenu;
  }

  get currencyCode(): string {
    return this.props.currencyCode;
  }

  //
  // Renderers
  //

  renderHeader() {
    const price = this.orderMenu.getTotalPrice() * this.props.quantity;

    const className = classNames('order_menu_view__header', {
      'order_menu_view__header_with_price': price > 0
    })

    return (
      <div className={className}>
        {this.renderQuantity()}
        {this.renderName()}
        {this.renderPrice(price)}
      </div>
    );
  }

  renderQuantity() {
    return (
      <div className="order_menu_view__quantity">
        <span>{this.props.quantity}x</span>
      </div>
    );
  }

  renderName() {
    return (
      <div className="order_menu_view__name">
        {this.orderMenu.name}
      </div>
    );
  }

  renderPrice(price: number) {
    if (price > 0) {
      return (
        <div className="order_menu_view__price">
          {CurrencyUtils.formatPriceWithCurrency(price, this.currencyCode)}
        </div>
      );
    }

    return (null);
  }

  renderComment() {
    if (_.isEmpty(this.orderMenu.comment)) {
      return (
        null
      );
    }

    return (
      <div className="order_menu_view__comment">
        {this.orderMenu.comment}
      </div>
    )
  }

  renderParts() {
    return (
      <div className="order_menu_view__parts">
        {this.orderMenu.parts.map((orderMenuPart: OrderMenuPart, index) => {
          return (
            <OrderMenuPartView
              key={`${orderMenuPart.id}_${index}`}
              orderMenuPart={orderMenuPart}
              currencyCode={this.currencyCode}
            />
          );
        })}
      </div>
    );
  }

  render() {
    return (
      <div className="order_menu_view">
        {this.renderHeader()}
        {this.renderComment()}
        {this.renderParts()}
      </div>
    );
  }

}
